import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { resetPasswordApi } from '../../apis';
import { handleApiError } from '../../helpers';
import { ResetPasswordDto } from '../../interfaces';
import useResetError from '../useResetError';

const useUpdatePassword = () => {
  const { hash } = useParams<{ hash: string }>();

  const [submiting, setSubmitting] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const { error, setError } = useResetError();

  const onSubmitHandler = (payload: ResetPasswordDto) => {
    setSubmitting(true);
    setError(null);

    payload.token = hash;

    const { confirm_password, ...rest } = payload;

    resetPasswordApi(rest)
      .then(() => {
        setSubmitting(false);
        setSuccess(true);
      })
      .catch((error) => {
        setSubmitting(false);
        setError(handleApiError(error));
      });
  };

  return { onSubmitHandler, submiting, success, error };
};

export default useUpdatePassword;
